import { render, staticRenderFns } from "./compare-responses-table.vue?vue&type=template&id=16f25954&scoped=true&"
import script from "./compare-responses-table.vue?vue&type=script&lang=ts&"
export * from "./compare-responses-table.vue?vue&type=script&lang=ts&"
import style0 from "./compare-responses-table.vue?vue&type=style&index=0&id=16f25954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f25954",
  null
  
)

export default component.exports